import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { UrlTree, Route, UrlSegment, Router } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { featureToggleStore } from '@cde-fe-app/app/shared/state/feature-toggle/feature-toggle.store';
import { AuthGuard } from './auth.guard';
import { Features } from '../models/feature-toggle.model';

export function canLoadAginConnectionManagerRouteGuard(
  route: Route,
  segments: UrlSegment[]
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  const router = inject(Router);
  const authGuard = inject(AuthGuard);
  const store = inject(featureToggleStore);

  return combineLatest([
    authGuard.canLoad(route, segments) as Promise<boolean | UrlTree>,
    toObservable(store.featureToggles),
    toObservable(store.featureTogglesInitialized),
  ]).pipe(
    filter(
      ([authorizedCanLoad, _featureToggles, featureTogglesInitialized]) =>
        authorizedCanLoad && featureTogglesInitialized
    ),
    map(
      ([_auth, featureToggles, _featureTogglesInitialized]) =>
        featureToggles?.some(toggle => toggle.featureId === Features.AGIN_CONNECTION_MANAGER) ?? false
    ),
    tap(hasFeatureToggle => {
      if (!hasFeatureToggle) {
        void router.navigate(['dashboard']);
      }
    })
  );
}
